/* Coral Attribution V2 — main theme — shadow/no marketing delivery. */
(function (global) {
  'use strict';

  const ATTR_ENDPOINT = 'https://n8n.coralpontocruz.com.br/webhook/v2-shadow/attribution';
  const OCCURRENCE_PREFIX = 'coral_v2_occurrence:';
  const KEYS = Object.freeze({
    visitor: 'coral_v2_visitor_id',
    session: 'coral_v2_session_id',
    sessionTouched: 'coral_v2_session_touched_at',
    flow: 'coral_v2_flow_id',
    snapshot: 'coral_v2_snapshot_id',
    consent: 'coral_v2_consent_fingerprint'
  });
  const CLICK_KEYS = Object.freeze(['gclid', 'gbraid', 'wbraid', 'fbclid']);
  const UTM_KEYS = Object.freeze(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']);
  const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const SESSION_IDLE_MS = 30 * 60 * 1000;
  const MAX_SNAPSHOT_ATTEMPTS = 3;
  const MAX_CART_ATTEMPTS = 4;
  const PAGE_ENTRY_URL = typeof global.__coralV2InitialUrl === 'string' ? global.__coralV2InitialUrl : global.location.href;

  function opaqueId() {
    if (typeof global.crypto.randomUUID === 'function') return global.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    global.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
  }

  function requireOpaqueId(value, field) {
    if (!UUID_V4.test(String(value || ''))) throw new Error(field + '_invalid');
    return String(value);
  }

  function normalizeConsent(input) {
    const value = input || {};
    return Object.freeze({
      version: String(value.version || 'v2'),
      analytics_storage: value.analytics_storage === true,
      ad_storage: value.ad_storage === true,
      ad_user_data: value.ad_user_data === true,
      ad_personalization: value.ad_personalization === true
    });
  }

  function consentFingerprint(consent) { return JSON.stringify(consent); }
  function clearIdentity() { for (const key of Object.values(KEYS)) sessionStorage.removeItem(key); }

  function getVisitorId() {
    let value = sessionStorage.getItem(KEYS.visitor);
    if (!UUID_V4.test(String(value || ''))) {
      value = opaqueId();
      sessionStorage.setItem(KEYS.visitor, value);
    }
    return value;
  }

  function getSessionId() {
    const now = Date.now();
    const touched = Number(sessionStorage.getItem(KEYS.sessionTouched) || 0);
    let value = sessionStorage.getItem(KEYS.session);
    if (!UUID_V4.test(String(value || '')) || !touched || now - touched > SESSION_IDLE_MS) {
      value = opaqueId();
      sessionStorage.setItem(KEYS.session, value);
      sessionStorage.removeItem(KEYS.flow);
      sessionStorage.removeItem(KEYS.snapshot);
    }
    sessionStorage.setItem(KEYS.sessionTouched, String(now));
    return value;
  }

  function originalUtms(url) {
    const params = new URL(url).searchParams;
    const out = {};
    for (const key of UTM_KEYS) {
      const value = params.get(key);
      if (value !== null) out[key] = value;
    }
    return out;
  }

  function allowedClickIds(url, consent) {
    if (!consent.ad_storage) return {};
    const params = new URL(url).searchParams;
    const out = {};
    for (const key of CLICK_KEYS) {
      const value = params.get(key);
      if (value !== null) out[key] = value;
    }
    return out;
  }

  function sanitizeLandingUrl(url, consent) {
    const parsed = new URL(url);
    if(parsed.protocol!=='https:'||!parsed.hostname||/@|%0[ad]/i.test(parsed.pathname))throw new Error('landing_url_invalid');
    return parsed.origin + parsed.pathname;
  }

  function currentFlow(consent) {
    const fingerprint = consentFingerprint(consent);
    if (sessionStorage.getItem(KEYS.consent) !== fingerprint) {
      sessionStorage.setItem(KEYS.consent, fingerprint);
      sessionStorage.removeItem(KEYS.flow);
      sessionStorage.removeItem(KEYS.snapshot);
    }
    let flow = sessionStorage.getItem(KEYS.flow);
    if (!UUID_V4.test(String(flow || ''))) {
      flow = opaqueId();
      sessionStorage.setItem(KEYS.flow, flow);
    }
    return flow;
  }

  function retryDelay(ms) { return new Promise(resolve => global.setTimeout(resolve, ms)); }

// Inserted into the pinned MAIN IIFE; no App Proxy or advanced journey code.
  const JOURNAL_PREFIX = 'coral_v2_capability:';
  const PENDING_PREFIX = 'coral_v2_pending_revoke:';
  let consentQueue = Promise.resolve();
  function capabilityToken() {
    const bytes = new Uint8Array(32); global.crypto.getRandomValues(bytes);
    return Array.from(bytes, b => b.toString(16).padStart(2,'0')).join('');
  }
  function persisted(key) {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    try { return JSON.parse(raw); } catch (_) { throw new Error('consent_journal_invalid'); }
  }
  function journalKeys(prefix) {
    const keys=[];
    for(let i=0;i<localStorage.length;i++){const key=localStorage.key(i);if(key&&key.startsWith(prefix))keys.push(key);}
    return keys;
  }
  async function storeRequest(body) {
    for(let attempt=0;attempt<MAX_SNAPSHOT_ATTEMPTS;attempt++){
      try {
        const response=await fetch(ATTR_ENDPOINT.replace('/attribution','/consent-capability'),{method:'POST',credentials:'omit',headers:{'Content-Type':'text/plain'},body:JSON.stringify(body)});
        const ack=await response.json();
        if(body.action==='create'&&ack.accepted===false&&!ack.durable_ack&&
          ((response.ok&&['NOT_COMMITTED','RESTRICTED','REVOKED','EXPIRED'].includes(ack.reconciliation))||
           (response.status===403&&ack.error==='CAPABILITY_DENIED')))return {terminal:true};
        if(!response.ok)throw new Error('consent_store_denied');
        if(ack.accepted!==true||ack.durable_ack!==true||ack.action!==body.action||ack.request_id!==body.request_id||ack.coral_flow_id!==body.coral_flow_id||!UUID_V4.test(String(ack.attribution_snapshot_id||''))||(body.action==='revoke'&&ack.attribution_snapshot_id!==body.attribution_snapshot_id))throw new Error('consent_ack_invalid');
        return ack;
      } catch (_) {if(attempt===MAX_SNAPSHOT_ATTEMPTS-1)throw new Error('consent_ack_unavailable');await retryDelay(250*Math.pow(2,attempt));}
    }
  }
  async function createAttributionSnapshotLocked(inputConsent) {
    const consent=normalizeConsent(inputConsent), fingerprint=consentFingerprint(consent);
    // Restore every incomplete create with EXACTLY its saved token/request before
    // deciding what to revoke. ACK loss must never silently rotate credentials.
    let createFailure=null;
    for(const key of journalKeys(JOURNAL_PREFIX)){
      const journal=persisted(key);
      if(!journal.snapshot){
        let ack;
        try{ack=await storeRequest(journal.body);}catch(e){createFailure=e;continue;}
        if(ack.terminal){localStorage.removeItem(key);createFailure=new Error('consent_create_terminal');continue;}
        journal.snapshot=ack.attribution_snapshot_id;localStorage.setItem(key,JSON.stringify(journal));
      }
      if(journal.fingerprint!==fingerprint){
        const pendingKey=PENDING_PREFIX+journal.body.coral_flow_id;
        if(!persisted(pendingKey))localStorage.setItem(pendingKey,JSON.stringify({action:'revoke',request_id:opaqueId(),coral_flow_id:journal.body.coral_flow_id,attribution_snapshot_id:journal.snapshot,capability:journal.body.capability}));
      }
    }
    // Durable pending work outlives flow rotation, network failure and reload.
    // Keep both old reference AND credential until the matching backend ACK.
    for(const key of journalKeys(PENDING_PREFIX)){
      const pending=persisted(key);await storeRequest(pending);
      localStorage.removeItem(JOURNAL_PREFIX+pending.coral_flow_id);localStorage.removeItem(key);
      if(sessionStorage.getItem(KEYS.flow)===pending.coral_flow_id)clearIdentity();
    }
    if(createFailure)throw createFailure;
    const oldFlow=sessionStorage.getItem(KEYS.flow), oldSnapshot=sessionStorage.getItem(KEYS.snapshot);
    // Legacy UUIDs are not possession evidence. Preserve their exact references,
    // never claim/revoke the old flow, and create a different capability below.
    if((oldFlow||oldSnapshot)&&!persisted(JOURNAL_PREFIX+oldFlow)){
      const archiveKey='coral_v2_legacy_transition:'+(oldFlow||oldSnapshot);
      if(!persisted(archiveKey)){
        const references={};
        for(const key of Object.values(KEYS)){const value=sessionStorage.getItem(key);if(value!==null)references[key]=value;}
        localStorage.setItem(archiveKey,JSON.stringify({version:1,state:'legacy_unverified',references}));
      }
    }
    if(oldFlow){
      const journal=persisted(JOURNAL_PREFIX+oldFlow);
      if(journal&&journal.fingerprint===fingerprint&&journal.snapshot){sessionStorage.setItem(KEYS.snapshot,journal.snapshot);return {coral_flow_id:oldFlow,attribution_snapshot_id:journal.snapshot};}
    }
    // Stage identities with the request; active references remain untouched until ACK.
    let key=journalKeys(JOURNAL_PREFIX).find(k=>persisted(k).fingerprint===fingerprint);
    let journal=key?persisted(key):null;
    if(!journal){
      const flowId=opaqueId();key=JOURNAL_PREFIX+flowId;
      const body={action:'create',request_id:opaqueId(),coral_flow_id:flowId,capability:capabilityToken(),consent};
      if(consent.analytics_storage)Object.assign(body,{visitor_id:opaqueId(),session_id:opaqueId(),landing_url:sanitizeLandingUrl(PAGE_ENTRY_URL,consent)});
      journal={body,fingerprint,snapshot:null};localStorage.setItem(key,JSON.stringify(journal));
    }
    if(!journal.snapshot){
      const ack=await storeRequest(journal.body);
      if(ack.terminal){localStorage.removeItem(key);throw new Error('consent_create_terminal');}
      journal.snapshot=ack.attribution_snapshot_id;localStorage.setItem(key,JSON.stringify(journal));
    }
    const flowId=journal.body.coral_flow_id;
    if(consent.analytics_storage){
      sessionStorage.setItem(KEYS.visitor,journal.body.visitor_id);
      sessionStorage.setItem(KEYS.session,journal.body.session_id);
      sessionStorage.setItem(KEYS.sessionTouched,String(Date.now()));
    }
    sessionStorage.setItem(KEYS.consent,fingerprint);
    sessionStorage.setItem(KEYS.flow,flowId);
    sessionStorage.setItem(KEYS.snapshot,journal.snapshot);
    return {coral_flow_id:flowId,attribution_snapshot_id:journal.snapshot};
  }
  function createAttributionSnapshot(inputConsent) {
    const job=consentQueue.then(()=>createAttributionSnapshotLocked(inputConsent));
    consentQueue=job.catch(()=>{});return job;
  }

  async function writeYampiCartLink(ids) {
    const coralFlowId = requireOpaqueId(ids && ids.coral_flow_id, 'coral_flow_id');
    const snapshotId = requireOpaqueId(ids && ids.attribution_snapshot_id, 'attribution_snapshot_id');
    const journal=persisted(JOURNAL_PREFIX+coralFlowId);
    if(!journal||journal.snapshot!==snapshotId||persisted(PENDING_PREFIX+coralFlowId)||sessionStorage.getItem(KEYS.flow)!==coralFlowId||sessionStorage.getItem(KEYS.snapshot)!==snapshotId)throw new Error('cart_link_not_acknowledged');
    for (let attempt = 1; attempt <= MAX_CART_ATTEMPTS; attempt += 1) {
      const response = await fetch('/cart/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{coral_flow_id:coralFlowId,attribution_snapshot_id:snapshotId}}),keepalive:true});
      if (response.ok) return;
      if (attempt === MAX_CART_ATTEMPTS || (response.status !== 429 && response.status < 500)) break;
      await retryDelay(300 * Math.pow(2, attempt - 1));
    }
    throw new Error('cart_attribute_write_failed');
  }

  async function clearCartLink() {
    const response = await fetch('/cart/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{coral_flow_id:'',attribution_snapshot_id:''}}),keepalive:true});
    if (!response.ok) throw new Error('cart_attribute_clear_failed');
  }

  function applyConsent(inputConsent) {
    const consent = normalizeConsent(inputConsent);
    const job=consentQueue.then(async()=>{
      const ids = await createAttributionSnapshotLocked(consent);
      await writeYampiCartLink(ids);
      return {status:consent.analytics_storage?'attribution_linked':'technical_origin_linked',...ids};
    });
    consentQueue=job.catch(()=>{});return job;
  }

  async function prepareFastCheckout(inputConsent) {
    try { await applyConsent(inputConsent); return true; } catch (_) { return false; }
  }

  function occurrenceKey(eventName, logicalActionKey) { return OCCURRENCE_PREFIX + eventName + ':' + logicalActionKey; }
  function createOccurrence(eventName, logicalActionKey) { const event_id=opaqueId(); sessionStorage.setItem(occurrenceKey(eventName,logicalActionKey),event_id); return event_id; }
  function reuseOccurrence(eventName, logicalActionKey) { return sessionStorage.getItem(occurrenceKey(eventName,logicalActionKey)); }
  function clearOccurrence(eventName, logicalActionKey) { sessionStorage.removeItem(occurrenceKey(eventName,logicalActionKey)); }

  global.CoralAttributionV2 = Object.freeze({applyConsent,createAttributionSnapshot,writeYampiCartLink,clearCartLink,prepareFastCheckout,createOccurrence,reuseOccurrence,clearOccurrence});
})(window);
